import React, { useEffect } from 'react';
import { Grid } from '@material-ui/core';
import { apiPost } from '../../api/client';
import CircularProgress from '@material-ui/core/CircularProgress';

export default function RegisterSubscription() {
  useEffect(() => {
    const SubscriptionDetails = localStorage.getItem('SubscriptionDetails')
      ? JSON.parse(localStorage.getItem('SubscriptionDetails'))
      : '';
    var moment = require('moment');
    var date = moment();
    var endDate = SubscriptionDetails
      ? moment().add(
          1,
          [
            'price_1Ix6m3GXGp4IxVFOTCkG6xJl',
            'price_1Ix8zvGXGp4IxVFOEoDHO6Nm',
            'price_1Ix916GXGp4IxVFOkoKQTfH7',
          ].includes(SubscriptionDetails.subscriptionplanid)
            ? 'M'
            : 'Y'
        )
      : null;
    SubscriptionDetails &&
      apiPost('/subscriptions', {
        subscriptionPlanId: Number(SubscriptionDetails.subscriptionplanid),
      })
        .then(() => {
          localStorage.setItem('SubscriptionDetails', '');
          window.location.href = '/registersubscription';
        })
        .catch((err) => {
          alert(`ERR: ${err}`);
          console.log(err);
        });
  });
  return (
    <Grid container direction="column" justify="center" alignContent="center">
      <Grid container justify="center">
        <CircularProgress />
      </Grid>
    </Grid>
  );
}
